/* @generated */

// ../src/list/list.tsx
import * as React7 from "react";
import cls3 from "classnames";

// ../src/list/item.tsx
import * as React3 from "react";
import cls from "classnames";

// ../src/list/context.tsx
import * as React from "react";
var ListContext = React.createContext({
  isSelectable: false,
  spacing: "medium",
  verticalAlign: "center"
});

// ../src/list/item.tsx
import { useFirstDefined } from "@dropbox/dig-components/hooks";

// ../src/_global/useCustomSpacing.tsx
import * as React2 from "react";
var addStyleIfDefined = (styling, styleName, ...args) => {
  const validStyleValue = args.find((arg) => arg !== void 0);
  if (validStyleValue === void 0) {
    return styling;
  }
  return {
    ...styling,
    [styleName]: validStyleValue
  };
};
var useCustomSpacing = ({
  padding,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingY,
  paddingX
}) => {
  return React2.useMemo(() => {
    let styling = {};
    styling = addStyleIfDefined(styling, "padding", padding);
    styling = addStyleIfDefined(styling, "paddingLeft", paddingX, paddingLeft);
    styling = addStyleIfDefined(styling, "paddingRight", paddingX, paddingRight);
    styling = addStyleIfDefined(styling, "paddingTop", paddingY, paddingTop);
    styling = addStyleIfDefined(styling, "paddingBottom", paddingY, paddingBottom);
    return styling;
  }, [padding, paddingBottom, paddingLeft, paddingRight, paddingTop, paddingX, paddingY]);
};

// ../src/list/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var contentCls = "dig-1gsd8yoh_21-1-1";
var listClasses = "dig-1gsd8yo5_21-1-1";
var listItemAccessory = "dig-1gsd8yo1_21-1-1";
var listItemElement = "dig-1gsd8yo2_21-1-1";
var listItemGapVar = "var(--dig-1gsd8yo0_21-1-1)";
var listItemSelectableVariant = "dig-1gsd8yo3_21-1-1";
var listItemVariants = _7a468({ defaultClassName: "dig-1gsd8yo7_21-1-1", variantClassNames: { alignment: { center: "dig-1gsd8yo8_21-1-1", top: "dig-1gsd8yo9_21-1-1" }, spacing: { xsmall: "dig-1gsd8yoa_21-1-1", small: "dig-1gsd8yob_21-1-1", medium: "dig-1gsd8yoc_21-1-1", large: "dig-1gsd8yod_21-1-1" }, selectable: { false: "dig-1gsd8yoe_21-1-1", true: "dig-1gsd8yof_21-1-1 dig-1gsd8yo6_21-1-1", isSelected: "dig-1gsd8yog_21-1-1 dig-1gsd8yo6_21-1-1" } }, defaultVariants: { alignment: "center", spacing: "small", selectable: false }, compoundVariants: [] });
var listItemWrapper = "dig-1gsd8yo4_21-1-1";

// ../src/list/item.tsx
import { assignInlineVars } from "@vanilla-extract/dynamic";
import "focus-visible";
var Item = React3.forwardRef((props, ref) => {
  const {
    children,
    className,
    isSelected = false,
    minHeight = "auto",
    spacing,
    verticalAlign,
    padding,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    paddingX,
    paddingY,
    style,
    isSelectable,
    withSubList,
    tagName: TagName = "span",
    gap = "medium",
    wrapperProps = {},
    ...rest
  } = props;
  const context = React3.useContext(ListContext);
  const gapValue = React3.useMemo(() => {
    if (gap === "xsmall") {
      return "4px";
    } else if (gap === "small") {
      return "8px";
    } else if (gap === "medium") {
      return "12px";
    } else if (gap === "large") {
      return "16px";
    } else {
      return gap + "px";
    }
  }, [gap]);
  const styles = {
    ...useCustomSpacing({
      padding,
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingBottom,
      paddingX,
      paddingY
    }),
    minHeight: minHeight !== "auto" ? minHeight : void 0,
    ...style,
    ...assignInlineVars({ [listItemGapVar]: gapValue })
  };
  const _isSelectable = useFirstDefined(isSelectable, context.isSelectable);
  const _verticalAlign = verticalAlign || context.verticalAlign;
  const _spacing = spacing || context.spacing || "small";
  const alignment = _verticalAlign === "top" ? "Top" : "Center";
  const selectableStatus = isSelected && _isSelectable ? "isSelected" : _isSelectable;
  return /* @__PURE__ */ React3.createElement(
    "span",
    {
      role: "listitem",
      ...wrapperProps,
      className: cls("dig-List-item-wrapper", listItemWrapper, wrapperProps.className || ""),
      ref
    },
    /* @__PURE__ */ React3.createElement(
      TagName,
      {
        className: cls(
          "dig-List-item",
          `dig-List-item--${_spacing}`,
          `dig-list-item--align${alignment}`,
          listItemVariants({
            alignment: _verticalAlign,
            spacing: _spacing,
            selectable: selectableStatus
          }),
          className,
          {
            "dig-List-item--isSelected": _isSelectable && isSelected,
            "dig-List-item--isSelectable": _isSelectable,
            [listItemSelectableVariant]: _isSelectable
          }
        ),
        style: styles,
        ...rest
      },
      children
    ),
    withSubList
  );
});
Item.displayName = "Item";

// ../src/list/content.tsx
import * as React4 from "react";
import cls2 from "classnames";
var Content = ({ children, className, ...rest }) => {
  return /* @__PURE__ */ React4.createElement(
    "span",
    {
      className: cls2(
        "dig-List-content dig-List-item-element",
        contentCls,
        listItemElement,
        className
      ),
      ...rest
    },
    children
  );
};
Content.displayName = "Content";

// ../src/list/accessory.tsx
import * as React5 from "react";
import classnames from "classnames";
var Accessory = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ React5.createElement(
    "span",
    {
      className: classnames(
        "dig-List-accessory dig-List-item-element",
        listItemElement,
        listItemAccessory,
        className
      ),
      ...rest
    },
    children
  );
};

// ../src/list/label.tsx
import * as React6 from "react";
import { Text } from "@dropbox/dig-components/typography";
var Label = ({ withText, children, ...rest }) => {
  return /* @__PURE__ */ React6.createElement(Item, { isSelectable: false, ...rest }, withText && /* @__PURE__ */ React6.createElement(Content, null, /* @__PURE__ */ React6.createElement(Text, { variant: "label", size: "small", color: "subtle", isBold: true }, withText)), !withText && children);
};
Label.displayName = "List.Label";

// ../src/list/list.tsx
import { useFirstDefined as useFirstDefined2 } from "@dropbox/dig-components/hooks";
var List = ({
  isSelectable,
  spacing = "medium",
  children,
  className,
  padding,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  paddingX,
  paddingY,
  style,
  verticalAlign = "center",
  ...rest
}) => {
  const ctx = React7.useContext(ListContext);
  const _isSelectable = useFirstDefined2(isSelectable, ctx.isSelectable) || false;
  const spacingStyles = useCustomSpacing({
    padding,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    paddingX,
    paddingY
  });
  return /* @__PURE__ */ React7.createElement(
    ListContext.Provider,
    {
      value: {
        isSelectable: _isSelectable,
        spacing,
        verticalAlign
      }
    },
    /* @__PURE__ */ React7.createElement(
      "span",
      {
        role: "list",
        className: cls3("dig-List", listClasses, className),
        style: { ...style, ...spacingStyles },
        ...rest
      },
      children
    )
  );
};
List.displayName = "List";
List.Item = Item;
List.Content = Content;
List.Accessory = Accessory;
List.Label = Label;
export {
  List
};
